export default __webpack_public_path__ + "static/0-bda02883f890b956e460f7b1a4378677.png";